import './LogoLoader.css';

const LogoLoader = ({ open, message = 'Loading...' }) => {
  if (!open) return null;
  return (
    <div className="logo-backdrop" role="status" aria-live="polite" aria-label={message}>
      <div className="logo-box">
        <div className="logo-blocks">
          <div className="lb-green" />
          <div className="lb-blue" />
          <div className="lb-red" />
          <div className="lb-orange" />
        </div>
        <span className="logo-label">{message}</span>
      </div>
    </div>
  );
};

export default LogoLoader;
